import { Cluster, MarkerClusterer } from '@googlemaps/markerclusterer';
//import { } from 'MarkerClusterer';


export interface IMapsModuleOptions {
    centerLat: number;
    centerLng: number;
    zoom?: number;
    mapTypeControl?: boolean;
    fullscreenControl?: boolean;
}

export default class MapsModule {
    private _map: google.maps.Map;
    private _selectorId: string;
    private _options: IMapsModuleOptions;
    private infoWindows: { [pAnlaegId: number]: google.maps.InfoWindow } = {};
    private markers: { [pAnlaegId: number]: google.maps.Marker } = {};

    constructor(selectorId: string, options: IMapsModuleOptions) {
        this._selectorId = selectorId;
        this._options = options;
        this._map = this.initMapsModule(selectorId, options);

        this.addMapEventListener();
    }

    public getMap(): google.maps.Map {
        return this._map;
    }

    public addMarkerToCluster(uniqueidentifier: number, lat: number, lng: number, title: string): google.maps.Marker {
        var coordinate: google.maps.LatLng = new google.maps.LatLng(lat, lng);

        var marker = new google.maps.Marker({
            position: coordinate,
            title: title,
            icon: "/Content/images/map-icon.png"
        });

        this.markers[uniqueidentifier] = marker;
        marker.addListener("click", () => this.showInfoWindow(uniqueidentifier));

        return marker;
    }

    public createCluster() {
        var markers = this.getMarkers();

        let renderer = {
            render({count, position}: Cluster ) {
              return new google.maps.Marker({
                position,
                icon: {
                  url: `/Content/icons/clustericons/m1.png`,
                  scaledSize: new google.maps.Size(53, 53),
                },
                label: {
                    color: "white",
                    text: ""
                },
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              });
            }
          }

        var markerCluster = new MarkerClusterer(
            {
                map: this._map,
                markers: markers,
                renderer: renderer
            });
    }

    public addMarker(uniqueidentifier: number, lat: number, lng: number, title: string) {
        var coordinate: google.maps.LatLng = new google.maps.LatLng(lat, lng);

        var marker = new google.maps.Marker({
            position: coordinate,
            map: this._map,
            title: title,
            icon: "/Content/images/map-icon.png"
        });

        this.markers[uniqueidentifier] = marker;
        marker.addListener("click", () => this.showInfoWindow(uniqueidentifier));
    }

    private getMarkers() {
        var markers = [];
        for (let key in this.markers) {
            markers.push(this.markers[key]);
        }

        return markers;
    }

    public addInfoWindow(uniqueidentifier: number, imageUrl: string, navn: string, antalPladser: string, adresse: string, postnummerby: string, url: string) {
        var html = this.createInfoWindowHtml(imageUrl, navn, antalPladser, adresse, postnummerby, url);
        var infoWindow = new google.maps.InfoWindow({
            content: html
        });

        this.infoWindows[uniqueidentifier] = infoWindow;

        google.maps.event.addListener(infoWindow, 'domready', () => {
            var iwOuter = $('.gm-style-iw');

            var iwBackground = iwOuter.prev();
            iwBackground.css({ 'display': 'none' });
            this.initInfoWindowEventListeners();
        });
    }

    private addMapEventListener() {
        google.maps.event.addListener(this._map, 'click', () => {
            this.closeAllInfoWindows();
        });
    }

    private initMapsModule(selectorId: string, options: IMapsModuleOptions): google.maps.Map {
        var zoom = options.zoom !== undefined ? options.zoom : 14;
        var mapTypeControl = options.mapTypeControl !== undefined ? options.mapTypeControl : true;
        var fullscreenControl = options.fullscreenControl !== undefined ? options.fullscreenControl : true;

        return new google.maps.Map(document.getElementById(selectorId), {
            center: { lat: options.centerLat, lng: options.centerLng },
            zoom: zoom,
            mapTypeControl: mapTypeControl,
            fullscreenControl: fullscreenControl,
            styles: [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]
        });
    }

    private createInfoWindowHtml = (imageUrl: string, navn: string, antalPladser: string, adresse: string, postnummerby: string, url: string): string => {
        var html = `
        <div class="scrollFix">
            <div class="info-window-card">
                <div class="shadow-container">
                    <div class="close-btn">
                        <svg class="embla-icon" aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <use xlink:href="/dist/icons/sprite.symbol.svg#remove"></use>
                        </svg>
                    </div>
                    <img class="card-image img-responsive" src="${imageUrl}"/>
                    <div class="info-window-content-wrapper">
                        <div class="card-header display-4">${navn}</div>   
                        <p>${antalPladser}</p>
                    </div>        
                    <div class="navigation-wrapper">
                        <div class="navigation-content">
                            <div class="overflow-ellipsis navigation-text">
                                <p>${adresse}</p>
                                <p>${postnummerby}</p>
                            </div>
                            <a href="${url}" class="card-arrow">
                                <svg class="embla-icon " aria-hidden="true" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <use xlink:href="/dist/icons/sprite.symbol.svg#forward"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>                
            </div>
        </div>`;

        return html;
    }

    private initInfoWindowEventListeners() {
        $('.close-btn').off().on('click', () => {
            this.closeAllInfoWindows();
        });
    }

    private closeAllInfoWindows() {
        for (let key in this.infoWindows) {
            let infoWindow = this.infoWindows[key];
            infoWindow.close();
        }
    }

    private showInfoWindow = (pAnlaegId: number) => {
        this.closeAllInfoWindows();
        var infoWindow = this.infoWindows[pAnlaegId];
        var marker = this.markers[pAnlaegId];
        if (infoWindow != null && marker != null) {
            infoWindow.open(this._map, marker);
        }
    }
}


// WEBPACK FOOTER //
// ./Content/scripts/modules/maps/maps-module.ts